export const ALLOWED_DATADOG_SITES = [
  'datadoghq.com',
  'datadoghq.eu',
  'us3.datadoghq.com',
  'us5.datadoghq.com',
  'ap1.datadoghq.com',
  'ddog-gov.com'
] as const

export const SENSITIVE_QUERY_KEYS = ['token', 'key', 'password', 'auth', 'secret', 'access_token', 'sessionid'] as const

export const COUNTRY_LABELS: Record<string, string> = {
  AUS: 'Australia',
  AU: 'Australia',
  USA: 'United States',
  US: 'United States'
}

export const MAX_INPUT_LENGTH = 64

export const ENVIRONMENT_SAMPLING_RATES = {
  test: {
    session: 100,
    replay: 20,
    logs: 20,
    trace: 20
  },
  staging: {
    session: 10,
    replay: 20,
    logs: 20,
    trace: 20
  },
  prod: {
    session: 10,
    replay: 20,
    logs: 20,
    trace: 20
  }
} as const

export const DEFAULT_SAMPLING_RATES = ENVIRONMENT_SAMPLING_RATES.prod
